// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OTAD","col":"styles_col__RWCQo"};